import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Download, Loader2, ShieldCheck, AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageHeader } from "@/components/common";
import { api, errMsg, download } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { toast } from "sonner";

export default function BackupDownload() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    sessionStorage.removeItem("after_login");
    api.get(`/backup-links/${token}`).then((r) => setInfo(r.data)).catch((e) => setError(errMsg(e)));
  }, [token]);
  const get = async () => {
    setBusy(true);
    try { await download(`/backup-links/${token}/file`); toast.success("Backup downloaded"); }
    catch (e) { toast.error("Download failed"); }
    finally { setBusy(false); }
  };
  return (
    <div>
      <PageHeader title="Download emailed backup" subtitle="Secure link from the backup email" />
      <div className="bg-white rounded-xl border p-6 max-w-xl" data-testid="backup-download-card">
        {!info && !error && <Loader2 className="h-5 w-5 animate-spin text-blue-800" data-testid="backup-download-loading" />}
        {error && <div className="flex gap-2 text-red-700" data-testid="backup-download-error"><AlertTriangle className="h-5 w-5 shrink-0" /> {error}</div>}
        {info && (
          <>
            <div className="flex items-center gap-2 font-semibold"><ShieldCheck className="h-5 w-5 text-emerald-600" /> {info.filename}</div>
            <dl className="grid grid-cols-2 gap-y-1 text-sm mt-4 text-slate-600" data-testid="backup-download-info">
              <dt>Backup created</dt><dd>{fmtDateTime(info.backup_created_at)}</dd>
              <dt>Employees</dt><dd>{info.employees}</dd>
              <dt>Transactions</dt><dd>{info.transactions}</dd>
              <dt>Size</dt><dd>{(info.size / 1024).toFixed(1)} KB</dd>
              <dt>Link expires</dt><dd data-testid="backup-download-expiry">{fmtDateTime(info.expires_at)}</dd>
            </dl>
            <Button className="mt-5 bg-blue-800 hover:bg-blue-900" disabled={busy} onClick={get} data-testid="backup-download-file-btn">
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Download className="h-4 w-4" />} Download backup file
            </Button>
          </>
        )}
      </div>
    </div>
  );
}
